import React from 'react';
import {Box, Typography} from "@mui/material";

const DocumentTabContent: React.FC = () => {
  return (
    <Box sx={{ padding: 3 }}>
      <Typography>
        No document have been uploaded for this property.
      </Typography>
    </Box>
  )
}

export default DocumentTabContent;